module.exports = __webpack_public_path__ + "img/signup-bg.9437388c.jpg";